<app-shive-grid #gridWrapperComponent [grid]="grid">
  <kendo-grid
    kendoGridSelectBy="id"
    scrollable="none"
    [data]="gridData()"
    [pageSize]="20"
    [selectable]="{ enabled: true, checkboxOnly: true }"
    [columnMenu]="{ filter: true }"
    #grid
  >
    <kendo-grid-checkbox-column
      [width]="40"
      [headerClass]="{ 'k-text-center': true }"
      class="list-selection-check"
      [resizable]="false"
      [columnMenu]="false"
      [showSelectAll]="true"
    >
    </kendo-grid-checkbox-column>

    <kendo-grid-column field="task.name" title="Bezeichnung" [class]="'!k-white-space-nowrap'">
      <ng-template kendoGridCellTemplate let-row>
        {{ row.task.name }}
      </ng-template>
    </kendo-grid-column>

    @if (budgetVisible()) {
      <kendo-grid-column field="task.budget" title="Budget" [class]="'!k-white-space-nowrap'">
        <ng-template kendoGridCellTemplate let-row>
          @let isHoursPerTask = project.budgetType === BudgetOptions.HoursPerTask;
          <div>
            @if (project.budgetType === BudgetOptions.HoursPerTask) {
              {{ row.spentSeconds | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }} /
              {{ row.budget | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
            }

            @if (project.budgetType === BudgetOptions.MonetaryPerTask) {
              {{ row.spentFees | shiveCurrency }} /
              {{ row.budget | shiveCurrency }}
            }
          </div>

          @let spent = isHoursPerTask ? row.spentSeconds : row.spentFees;
          <app-fuelbar [currentVal]="spent" [maxVal]="row.budget" [thin]="true"></app-fuelbar>
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-grid-column
      field="task.expendedHours"
      title="Aufwand (h)"
      [class]="'!k-white-space-nowrap'"
    >
      <ng-template kendoGridCellTemplate let-row>
        {{ row.spentSeconds | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
      </ng-template>
    </kendo-grid-column>

    @if (project.expenditureType === ExpenditureRateOptions.HourlyRatePerTask) {
      <kendo-grid-column
        field="task.expendedFees"
        title="Aufwand (Euro)"
        [class]="'!k-white-space-nowrap'"
      >
        <ng-template kendoGridCellTemplate let-row>
          {{ row.spentFees | shiveCurrency }}
        </ng-template>
      </kendo-grid-column>
    }
  </kendo-grid>
</app-shive-grid>
